import React, { useEffect } from 'react';

import { fg } from '@atlaskit/platform-feature-flags';
import TeamAvatar from '@atlaskit/teams-avatar';
import { ErrorWithContext } from '@atlassian/people-teams';

import { type ErrorWithStatus } from '../../types';
import { renderPeopleNavMenuExp } from '../analytics/experiences';

export const ICON_SIZE = 32;
export const MAX_POPUP_WIDTH = 480;
export const MIN_POPUP_WIDTH = 320;
// this max-height is copied from Confluence's styles.
export const MAX_POPUP_HEIGHT = 'calc(100vh - 79px)';

export function ImgIcon({ src, alt }: { src?: string; alt: string }) {
	if (fg('enable-team-avatar-switch')) {
		return <TeamAvatar size="medium" src={src} />;
	}
	return (
		<img
			src={src || ''}
			alt={alt}
			height={ICON_SIZE}
			width={ICON_SIZE}
			style={{ borderRadius: ICON_SIZE / 2 }}
		/>
	);
}

export function Buggy() {
	useEffect(() => {
		throw new Error('Something wrong inside People menu.');
	});

	return null;
}

export const fireRenderPeopleNavMenuFail = (error?: Error | ErrorWithStatus | ErrorWithContext) => {
	renderPeopleNavMenuExp.failure({
		metadata: {
			...(error && 'status' in error ? { status: error.status } : {}),
			...(error instanceof ErrorWithContext ? { context: error.context } : {}),
			error: error?.message,
		},
	});
};
